<template>
  <nav class="navbar navbar-expand-lg fixed-top navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">
        <img src="https://beauvoyage.net/BEAU%20VOYAGE%20LOGOTIPO_Mesa%20de%20trabajo%201%20copia.png" alt="Bootstrap" width="100">
      </a>
      <button class="navbar-toggler bg-dark" type="button" data-bs-toggle="collapse" data-bs-target="#navbarColor04"
        aria-controls="navbarColor04" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fa-solid fa-bars text-light"></i>
      </button>
      <div class="collapse navbar-collapse row justify-content-end" id="navbarColor04">
        <div class="col-12 row justify-content-end ">
          <div class="col-12 col-md-4 col-xl-3 mt-4 mt-md-0 bg-primary nvarNote row justify-content-center">
            <p class="nvarNoteText">Para ventas <b>+52 55 4540 1703</b></p>
          </div>
        </div>
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 col-12 col-md-7 col-xl-10 justify-content-end">
          <li class="nav-item ml-3 mr-md-0">
            <RouterLink to="/" class="nav-item nav-link h6" active-class="active">Inicio</RouterLink>


          </li>
          <li class="nav-item ml-3 mr-md-0">
            <RouterLink to="/MesaRegalos" class="nav-item nav-link h6" active-class="active">Mesa de regalos</RouterLink>


          </li>
          <!-- <li class="nav-item ml-3 mr-md-0">
            <RouterLink to="" class="nav-item nav-link h6" active-class="">Translados</RouterLink>


          </li> -->
         <!--  <li class="nav-item ml-3 mr-md-0">
            <RouterLink to="" class="nav-item nav-link h6" active-class="">Hoteles</RouterLink>


          </li> -->
          <li class="nav-item ml-3 mr-md-0">
            <RouterLink to="/Asesorias" class="nav-item nav-link h6" active-class="active">Asesoría</RouterLink>


          </li>
          <li class="nav-item ml-3 mr-md-0 pt-2">
            <EspecialBotton @update-estado="actualizarVariables" />
          </li>
          <li class="nav-item ml-3 mr-md-0">
            <a href="/login" class="nav-item nav-link h6"><i class="fa-regular fa-circle-user"></i> Iniciar sesión</a>

          </li>
        </ul>
        <div
          class="d-flex col-12 col-md-4 col-xl-2 justify-content-start justify-content-md-end justify-content-xl-end mt-3 mt-md-0 mb-3 mb-md-0">
          <a href="https://www.instagram.com/beauvoyageagencia"><i class="fa-brands fa-instagram mr-3 ml-md-3"></i></a>
          <a href="https://www.facebook.com/share/17TfNUmF6v/"><i
              class="fa-brands fa-facebook ml-0 mr-3 ml-md-3"></i></a>
          <a href="https://www.tiktok.com/@beau.voyage.agencia?_t=ZS-90de9UePT9k&_r=1"><i
              class="fa-brands fa-tiktok mr-3 ml-3"></i></a>

        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import EspecialBotton from './EspecialBotton.vue';
export default {
  name: "NvarWeb",
  data() {
    return {
      isActive: false,
      isActive2: false,
      isActive3: false
    }
  },
  components: {
    EspecialBotton
  },
  methods: {
    actualizarVariables(nuevosValores) {

      // Desestructuramos lo que viene del hijo
      this.isActive = nuevosValores.isActive;
      this.isActive2 = nuevosValores.isActive2;
      this.isActive3 = nuevosValores.isActive3;
      // Enviamos al padre
      this.$emit('update-estadoPadre', {
        isActive: this.isActive,
        isActive2: this.isActive2,
        isActive3: this.isActive3
      });
    }
  }

}

</script>